
import React from "react";
import { FileText, ArrowLeft, Save, Download, Printer, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";

interface DocumentHeaderProps {
  document: any;
  isDownloading: boolean;
  onBack: () => void;
  onSave: () => void;
  onDownloadPDF: () => void;
  onPrint: () => void;
  onCopy: () => void;
}

const DocumentHeader = ({
  document,
  isDownloading,
  onBack,
  onSave,
  onDownloadPDF,
  onPrint,
  onCopy
}: DocumentHeaderProps) => {
  return (
    <div className="p-4 bg-gradient-to-r from-blue-50 to-purple-50">
      <div className="flex items-center gap-2 justify-between">
        <div className="flex items-center gap-2">
          <Button onClick={onBack} variant="outline" size="sm" className="gap-1">
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </Button>
          <FileText className="h-5 w-5 text-blue-600" />
          <div>
            <h3 className="font-semibold text-gray-800">{document.title}</h3>
            <p className="text-sm text-gray-600">Tipo: {document.type}</p>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Button onClick={onSave} variant="default" size="sm">
            <Save className="h-4 w-4 mr-2" />
            Salvar
          </Button>
          
          <Button 
            onClick={onDownloadPDF} 
            variant="outline" 
            size="sm"
            disabled={isDownloading}
          >
            <Download className="h-4 w-4 mr-2" />
            {isDownloading ? "Gerando..." : "PDF"}
          </Button>
          
          <Button onClick={onPrint} variant="outline" size="sm">
            <Printer className="h-4 w-4 mr-2" />
            Imprimir
          </Button>
          
          <Button onClick={onCopy} variant="outline" size="sm">
            <Copy className="h-4 w-4 mr-2" />
            Copiar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DocumentHeader;
